exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".delete-item {\n  color: pink;\n  cursor: pointer;\n  display: block;\n  margin: 0 auto;\n  flex-shrink:1;\n}\n\n.delete-item:hover {\n  color: red;\n}\n\n.del-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-basis: 42px;\n}\n", "", {"version":3,"sources":["/Users/nprince/apps/react-easel/src/bootstrap4/ListDelField.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,cAAc;CACf;;AAED;EACE,WAAW;CACZ;;AAED;EACE,cAAc;EACd,uBAAuB;EACvB,wBAAwB;EACxB,oBAAoB;EACpB,iBAAiB;CAClB","file":"ListDelField.css","sourcesContent":[".delete-item {\n  color: pink;\n  cursor: pointer;\n  display: block;\n  margin: 0 auto;\n  flex-shrink:1;\n}\n\n.delete-item:hover {\n  color: red;\n}\n\n.del-wrapper {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  flex-basis: 42px;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?sourceMap!./src/bootstrap4/ListDelField.css
// module id = 275
// module chunks = 0